import { useNavigate } from 'react-router-dom'


const NotFound = () => {
    const navigate = useNavigate()


    return (
        <main className="container Dashboard">
            <div className="row mt-5">
                <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" />

                <div className="mt-5">
                    <div className='NotFound'>
                        <p className='NotFound__Title'>Lo sentimos. No encontramos la página que buscas.</p>
                        <button type="button" className='Btn__Adsl--Red NotFound__Button' onClick={() => navigate('/')}>Ir a la página de inicio</button>
                    </div>
                </div>
            </div>
        </main>
    )
}

export { NotFound };